import { LabelsContext } from 'helpers/contexts';
import React, { useContext, useState } from 'react';
import DesktopSecondScreen from './DesktopSecondScreen';
import MobileTemplateAndCompanySize from './MobileSecondScreen';
import { hasInvalidChars } from 'helpers/utilities';

function TemplateAndCompanySize(props) {
  const { signUp, global } = useContext(LabelsContext);
  const [companySize, setCompanySize] = useState(0);
  const [companySizeLabel, setCompanySizeLabel] = useState(0);
  const [companyName, setCompanyName] = useState('');
  const [businessType, setBusinessType] = useState('');
  const [businessTypeLabel, setBusinessTypeLabel] = useState('');
  const [companySizeError, setCompanySizeError] = useState('');
  const [businessTypeError, setBusinessTypeError] = useState('');
  const [companyNameError, setCompanyNameError] = useState('');

  const [isUpdating, setIsUpdating] = useState(false);

  const businessTypes = /** @type {const} */ ([
    {
      label: signUp.businessType.realEstate,
      icon: 'building',
      value: 'realEstate',
      iconTextMargin: '6px',
      padding: '6px 8px',
    },
    {
      label: signUp.businessType.education,
      icon: 'pencil',
      value: 'courses',
      iconTextMargin: '4px',
      padding: '6px 8px',
    },
    {
      label: signUp.businessType.insurance,
      icon: 'security',
      value: 'insurance',
      iconTextMargin: '5px',
      padding: '6px 8px',
    },
    {
      label: signUp.businessType.media,
      icon: 'bee',
      value: 'media',
      iconTextMargin: '4px',
      padding: '6px 8px',
    },
    {
      label: signUp.businessType.finance,
      value: 'finance',
      padding: '6px 8px',
    },
    {
      label: signUp.businessType.healthCare,
      value: 'healthcare',
      padding: '6px 8px',
    },
    {
      label: signUp.businessType.other,
      icon: 'flower',
      value: 'other',
      iconTextMargin: '6px',
      padding: '6px 8px',
    },
  ]);

  const isValidCompanyName = () => {
    if (companyName === '') {
      setCompanyNameError(global.requiredField);
      return false;
    }

    if (hasInvalidChars(companyName)) {
      setCompanyNameError(signUp.removeSpecialChars);
      return false;
    }

    return true;
  };

  const isValidCompanySize = () => {
    if (companySize === 0) {
      setCompanySizeError(global.requiredField);
      return false;
    }

    if (hasInvalidChars(companySize)) {
      setCompanySizeError(signUp.removeSpecialChars);
      return false;
    }

    return true;
  };

  const isValidIndustryType = () => {
    if (!businessType.length > 0) {
      setBusinessTypeError(global.requiredField);
      return false;
    }

    if (hasInvalidChars(businessType)) {
      setBusinessTypeError(signUp.removeSpecialChars);
      return false;
    }

    return true;
  };

  const validate = () => {
    const isCompanySizeValid = isValidCompanySize();
    const isIndustryTypeValid = isValidIndustryType();
    const isCompanyNameValid = isValidCompanyName();
    return isCompanySizeValid && isIndustryTypeValid && isCompanyNameValid;
  };

  const handleSubmit = () => {
    if (validate()) {
      setIsUpdating(true);
      props.onSubmit && props.onSubmit(companySize, businessType, businessTypeLabel, companyName, companySizeLabel);
    }
  };
  /**
   * Finds the label corresponding to a given value from an options list.
   *
   * @template T
   * @param {T} options
   * @param {T[number]['value']} value
   * @returns {T[number]['label'] | null} The label for the given value, or `null` if not found.
   */
  const getLabelFromValue = (options, value) => {
    const option = options.find((option) => option.value === value);
    return option?.label || null;
  };

  const handleBusinessTypeSelection = (businessType) => {
    const businessTypeLabel = getLabelFromValue(businessTypes, businessType);
    setBusinessType(businessType);
    setBusinessTypeLabel(businessTypeLabel);
    setBusinessTypeError('');
  };

  const handleCompanySizeSelection = (value) => {
    setCompanySize(value);
    const companySizelabel = getLabelFromValue(COMPANY_SIZE_OPTIONS, value);
    setCompanySizeLabel(companySizelabel);
    setCompanySizeError('');
  };

  const handleCompanyNameChange = (value) => {
    setCompanyNameError('');
    setCompanyName(value);
  };

  const sharedProps = {
    companySizeOptions: COMPANY_SIZE_OPTIONS,
    onSubmit: handleSubmit,
    onChipSelection: handleCompanySizeSelection,
    onBusinessTypeChange: handleBusinessTypeSelection,
    onCompanyNameChange: handleCompanyNameChange,
    companySize,
    businessType,
    businessTypeLabel,
    companySizeLabel,
    companySizeError: companySizeError,
    businessTypeError,
    companyNameError,
    isUpdating,
    companyName,
    businessTypes,
    shouldShowIcons: false, // This toggle turns on/off business type icons
    isRtl: props.isRtl,
  };

  return props.isMobileMode || props.isTabletBreakpoint ? (
    <MobileTemplateAndCompanySize {...sharedProps} />
  ) : (
    <DesktopSecondScreen {...sharedProps} />
  );
}

const COMPANY_SIZE_OPTIONS = /** @type {const} */ ([
  { label: '1-4', value: 9 },
  { label: '5-10', value: 10 },
  { label: '11-25', value: 4 },
  { label: '26-100', value: 11 },
  { label: '101-500', value: 6 },
  { label: '500+', value: 7 },
]);

export default TemplateAndCompanySize;
